import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7954016"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-mt-4" }
const _hoisted_2 = { class: "p-text-left p-px-3" }
const _hoisted_3 = { class: "p-text-bold f-size-20" }
const _hoisted_4 = {
  key: 0,
  class: "p-text-left p-px-3"
}
const _hoisted_5 = {
  key: 0,
  class: "p-text-bold f-size-20"
}
const _hoisted_6 = {
  key: 1,
  class: "text-secondary f-size-14"
}
const _hoisted_7 = { class: "my-2" }
const _hoisted_8 = {
  key: 2,
  class: "p-text-bold f-size-20"
}
const _hoisted_9 = {
  key: 1,
  class: "border-top p-px-3 p-py-3 p-mt-3"
}
const _hoisted_10 = { class: "border-x p-px-3 p-py-3 p-mt-3" }
const _hoisted_11 = { class: "p-d-flex p-jc-between" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100 p-text-left p-my-auto" }, [
  /*#__PURE__*/_createElementVNode("span", null, "จำนวน")
], -1))
const _hoisted_13 = { class: "w-100" }
const _hoisted_14 = { class: "p-inputgroup" }
const _hoisted_15 = { class: "p-p-3 p-text-left" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "product-footer shadow-lg p-px-3 p-pt-2" }
const _hoisted_18 = { class: "p-d-flex p-jc-between" }
const _hoisted_19 = { class: "w-100 p-pt-2 p-pr-1" }
const _hoisted_20 = { class: "w-100 p-pt-2 p-pl-1" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cutom-margin-bottom" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductImage = _resolveComponent("ProductImage")!
  const _component_ProductConfigOption = _resolveComponent("ProductConfigOption")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ProductImage, { productImages: _ctx.productImages }, null, 8, ["productImages"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.productName), 1)
    ]),
    (_ctx.productAdvancePrice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.productAdvancePrice.priceAfterDiscount !== 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " ฿" + _toDisplayString(_ctx.$filters.formatNumber(_ctx.productAdvancePrice.priceAfterDiscount)), 1))
            : _createCommentVNode("", true),
          (_ctx.productAdvancePrice.priceAfterDiscount !== 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                _createElementVNode("del", _hoisted_7, " ฿ " + _toDisplayString(_ctx.$filters.formatNumber(_ctx.productAdvancePrice.price)), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, " ฿ " + _toDisplayString(_ctx.$filters.formatNumber(_ctx.productAdvancePrice.price)), 1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isProductConfig)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.forceRefresh)
            ? (_openBlock(), _createBlock(_component_ProductConfigOption, {
                key: 0,
                productDetail: _ctx.parentProduct,
                onOnGetProductConfig: _ctx.onGetProductConfig
              }, null, 8, ["productDetail", "onOnGetProductConfig"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Button, {
              icon: "pi pi-plus",
              class: "p-button-success",
              style: _normalizeStyle({
                'background-color': _ctx.backgroundColor,
                'border-color': _ctx.backgroundColor,
              }),
              onClick: _ctx.onAddQuantity
            }, null, 8, ["style", "onClick"]),
            _createVNode(_component_InputText, {
              placeholder: "quantity",
              class: "input-quantity",
              modelValue: _ctx.quantity,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.quantity) = $event)),
              disabled: true
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              icon: "pi pi-minus",
              class: "p-button-danger",
              style: _normalizeStyle({
                'background-color': _ctx.backgroundColor,
                'border-color': _ctx.backgroundColor,
              }),
              onClick: _ctx.onRemoveQuantity
            }, null, 8, ["style", "onClick"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.productDescription)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            innerHTML: _ctx.productDescription
          }, null, 8, _hoisted_16))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_Button, {
            label: "เพิ่มใส่ตะกร้า",
            class: "w-100 p-button-outlined",
            disabled: _ctx.quantity == 0,
            style: _normalizeStyle({
              'border-color': _ctx.backgroundColor,
              color: _ctx.backgroundColor,
            }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onAddProductToCart(0)))
          }, null, 8, ["disabled", "style"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_Button, {
            label: "ซื้อเลย",
            class: "w-100",
            disabled: _ctx.quantity == 0,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onAddProductToCart(1))),
            style: _normalizeStyle({
              'background-color': _ctx.backgroundColor,
              'border-color': _ctx.backgroundColor,
            })
          }, null, 8, ["disabled", "style"])
        ])
      ])
    ]),
    _hoisted_21
  ]))
}